import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, PhoneCall } from 'lucide-react';

const HeroSection = () => {
   const navigate = useNavigate();
   const finImage="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/career.png";
  
    const handleButtonClick = () => {
      const section = document.getElementById('positions');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    };
  return (
    <section className="relative h-screen overflow-hidden isolate min-h-[75vh]">
      {/* Background with image */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${finImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            width: '100%',
            height: '100%'
          }}
        />
      </div>

      {/* Content container */}
      <div className="relative h-full z-10 container mx-auto px-6 lg:px-10 flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 lg:py-24 p-6"
        >
          {/* Content wrapper */}
          <div className="max-w-2xl w-full md:w-1/2 lg:w-3/5 text-white space-y-5 md:space-y-6 md:pr-8 pt-8 md:pt-4">
            
            {/* Title */}
            <h1 className="heading text-2xl md:text-3xl lg:text-4xl mb-4 font-bold leading-tight bg-gradient-to-r from-white to-[#A2B8D8] bg-clip-text text-transparent animate-slideUp py-4">
              Careers
            </h1>
            
            {/* Subtitle */}
            <h2 className="text-xl md:text-2xl font-medium text-white/90 mb-4 animate-fadeIn opacity-0" style={{ animationDelay: '0.3s' }}>
              Maxiom Wealth helps investors create and preserve wealth.
            </h2>
            
            {/* Description */}
            <p className="text-lg text-white/80 mb-8 leading-relaxed animate-fadeIn opacity-0" style={{ animationDelay: '0.6s' }}>
              We are not just in the business of managing investments or assets — we are in the art of cultivating prosperity.
            </p>
            
            {/* CTA Button */}
            <motion.button
              onClick={handleButtonClick}
              className="bg-[#F49611] text-white px-8 py-4 rounded-lg hover:transform hover:-translate-y-1 hover:shadow-lg transition-all duration-300 font-semibold"
              whileHover={{ 
                backgroundColor: '#F6A839',
                y: -2,
                boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
              }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.9 }}
            >
              View Open Positions
            </motion.button>
          </div>
        </motion.div>
      </div>

      {/* Optional decorative elements */}
      <motion.div 
        className="absolute bottom-0 right-0 w-full h-24 z-0"
        style={{
          background: 'linear-gradient(to top, rgba(0,0,0,0.3), transparent)'
        }}
      />
    </section>
  );
};

export default HeroSection;